import { Descriptions, Divider } from "antd";
import { selectCurrentBusiness } from "../../../businessesSlice";
import { useAppSelector } from "../../../../../app/hooks";
import { MissingTag } from "../BusinessDetailsModal";

export default function BusinessPayoutDetails() {
  const currentBusiness = useAppSelector(selectCurrentBusiness);

  return (
    <>
      <Descriptions
        title="Payout Schedule"
        labelStyle={{ opacity: 0.6, width: "130px" }}
      >
        <Descriptions.Item label="Payout Schedule">
          {currentBusiness?.payoutOptions?.schedule}
        </Descriptions.Item>
      </Descriptions>
      <Divider />
      <Descriptions
        title="Bank Details"
        labelStyle={{ opacity: 0.6, width: "130px" }}
      >
        <Descriptions.Item label="IBAN">
          {currentBusiness.bankAccountIban}
        </Descriptions.Item>
        <Descriptions.Item label="Name">
          {currentBusiness.bankName}
        </Descriptions.Item>
        <Descriptions.Item label="Account Number">
          {currentBusiness.bankAccountNumber || MissingTag}
        </Descriptions.Item>
        <Descriptions.Item label="BIC">
          {currentBusiness.bic || MissingTag}
        </Descriptions.Item>
        <Descriptions.Item label="Address">
          {/* {getFullAddress(currentBusiness.rootUser.address)} */}
          {!currentBusiness.bankAddress?.street
            ? MissingTag
            : `${currentBusiness.bankAddress?.street}, ${currentBusiness.bankAddress?.postcode} ${currentBusiness.bankAddress?.city}, ${currentBusiness.bankAddress?.country}`}
        </Descriptions.Item>
      </Descriptions>
    </>
  );
}
